import withDefaults from '@/components/withDefaults';

const ProductTag = withDefaults('div', {
  className: 'rounded bg-[#ECF389] px-1.5 text-center text-[10px]/6 font-medium text-black',
});

export default ProductTag;
